import { Link } from 'react-router-dom';
import { ctaContent } from '@/mocks/home';

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
          {ctaContent.title}
        </h2>
        <p className="text-base text-foreground-600 mb-8 leading-relaxed">
          {ctaContent.subtitle}
        </p>
        <Link
          to={ctaContent.buttonHref}
          className="inline-block px-10 py-4 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-xl text-base transition-colors whitespace-nowrap cursor-pointer"
        >
          {ctaContent.buttonText}
        </Link>
      </div>
    </section>
  );
}